import { fxgOrderGetMCToken, submitProductSuggestion, getProductSuggestionResult } from '@/api/prod/center/index';

const APPID = '6839207088506488334';

export default {
  state: () => ({
    suggestionTotalCount: 0,
    suggestionTaskId: '',
    suggestionResult: {},
    suggestionPollingTimer: null,
    ecopenInitializedShops: {},
  }),
  mutations: {
    setSuggestionTotalCount(state, val) {
      state.suggestionTotalCount = val;
    },
    setSuggestionTaskId(state, val) {
      state.suggestionTaskId = val;
    },
    setSuggestionResult(state, val) {
      state.suggestionResult = val;
    },
    setSuggestionPollingTimer(state, timer) {
      state.suggestionPollingTimer = timer;
    },
    setEcopenInitializedShop(state, { shopId, token }) {
      state.ecopenInitializedShops[shopId] = token;
    },
  },
  actions: {
    async startSuggestionPolling({ commit, state }) {
      if (state.suggestionTaskId) return;
      const res = await submitProductSuggestion();
      if(res.result === 1) {
        commit('setSuggestionTaskId', res.data);
      }
    },
    async fetchSuggestionResultAction({ commit, dispatch, state }) {
      const taskId = state.suggestionTaskId;
      if (!taskId) return;
      dispatch('stopSuggestionPolling');
      const res = await getProductSuggestionResult({ taskId });
      if (res.result === 1) {
        if (!res.data.finished) {
          const timer = setTimeout(() => {
            dispatch('fetchSuggestionResultAction');
          }, 1000);
          commit('setSuggestionPollingTimer', timer);
        } else {
          const data = res?.data || {};
          commit('setSuggestionResult', data);
          commit('setSuggestionTotalCount', (data.forceTotalCount || 0) + (data.suggestTotalCount || 0));
        }
      }
    },
    stopSuggestionPolling({ commit, state }) {
      if (state.suggestionPollingTimer) {
        clearTimeout(state.suggestionPollingTimer);
        commit('setSuggestionPollingTimer', null);
      }
    },
    resetSuggestionData({ commit, dispatch }) {
      dispatch('stopSuggestionPolling');
      commit('setSuggestionResult', {});
      commit('setSuggestionTotalCount', 0);
    },
    async initEcopen({ commit, state }, { shopId }) {
      if (state.ecopenInitializedShops[shopId]) return true;
      const res = await fxgOrderGetMCToken({ shopId });
      if (res.result !== 1) return false;
      const token = res?.data?.data?.token;
      if (!token) return false;
      window.ecopen.start({ token, appId: APPID, shopId });
      commit('setEcopenInitializedShop', { shopId, token });
      return true;
    },
  },
  getters: {
    suggestionTotalCount(state) {
      return state.suggestionTotalCount;
    },
    suggestionTaskId(state) {
      return state.suggestionTaskId;
    },
    suggestionResult(state) {
      return state.suggestionResult;
    },
    ecopenInitializedShops(state) {
      return state.ecopenInitializedShops;
    },
  },
};
